<template>
  <div class="bjtjfx-container">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="下单日期">
              <el-date-picker v-model="searchForm.time" format="yyyy年MM月dd日" value-format="yyyy-MM-dd" type="daterange"
                :clearable="false" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="组织">
              <el-select v-model="searchForm.group" style="width: 120px" @keyup.enter.native="Search" filterable>
                <el-option v-for="item in groupList" :key="item.groupid" :label="item.group_name"
                  :value="item.groupid" />
              </el-select>
            </el-form-item>
            <el-form-item label="订单类型">
              <el-select v-model="searchForm.orderType" style="width: 100px" @keyup.enter.native="Search" filterable clearable>
                <el-option-group label="">
                  <el-option label="正单" value="0" />
                  <el-option label="补单" :value="5" />
                </el-option-group>
                <el-option-group label="补单类型">
                  <el-option label="客改单" :value="1" />
                  <el-option label="增补单" :value="2" />
                  <el-option label="色板单" :value="3" />
                  <el-option label="售后单" :value="4" />
                </el-option-group>
              </el-select>
            </el-form-item>
            <el-form-item label="订单状态">
              <el-select v-model="searchForm.mark" style="width: 120px" @keyup.enter.native="Search" filterable clearable>
                <el-option-group label="">
                  <el-option label="进行中" :value="-1" />
                  <el-option label="已完成" :value="100" />
                  <el-option label="已取消" :value="99" />
                </el-option-group>
                <el-option-group label="进行中细分状态">
                  <el-option label="待接单" :value="2" />
                  <el-option label="售后处理" :value="3" />
                  <el-option label="技术评估" :value="4" />
                  <el-option label="拆单分配" :value="5" />
                  <el-option label="拆单" :value="6" />
                  <el-option label="审单" :value="88" />
                  <el-option label="订单确认" :value="7" />
                  <el-option label="待报价" :value="8" />
                  <el-option label="预付款" :value="9" />
                  <el-option label="工厂分派" :value="10" />
                  <el-option label="生产接单" :value="11" />
                  <el-option label="订单排产" :value="12" />
                  <el-option label="订单生产" :value="13" />
                </el-option-group>
              </el-select>
            </el-form-item>
            <el-form-item label="搜索关键字">
              <el-input v-model="searchForm.search" placeholder="关键字搜索" @keyup.enter.native="Search"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search">搜索</el-button>
              <el-button icon="el-icon-printer" style="margin-left: 10px;" size="small" :loading="excelLoading"
                @click="exportExcelAll">导出Excel</el-button>
            </el-form-item>
          </el-form>

          <div class="card-content">
            <div style="display: flex;">
              <el-checkbox v-model="searchForm.is_my" @change="Search">只查询我关联的</el-checkbox>
              <div style="font-size: 13px; color:#F56C6C; margin-left: 20px;">
                <i class="el-icon-info" style="font-size: 16px;" />
                提示：选中时，只会查询当前账号是经销商所关联的区域经理或销售客服的订单
              </div>
            </div>
            <el-row :gutter="20" style="padding-top: 20px">
              <el-col :span="24">
                <el-table :data="orderList" v-loading="loading" stripe style="width: 100%" :row-style="{cursor: 'pointer'}" empty-text="暂无数据" @row-click="seeOrder">
                  <el-table-column label="序号" type="index" align="center" fixed="left" width="50"></el-table-column>
                  <el-table-column prop="orderNum" label="订单号" align="center" fixed="left" width="120">
                    <template slot-scope="scope">
                      <div class="orderNum" v-if="scope.row.orderNum" @click.stop="openDetails(scope.row)">
                        {{ scope.row.orderNum }}
                      </div>
                      <span style="font-weight: 500; color: #999999" v-else>N/A</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="生产单号" width="90" align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="font-weight: 500; color: #409EFF" v-if="scope.row.productNum">{{ scope.row.productNum }}</span>
                      <span style="font-weight: 500; color: #999999" v-else>N/A</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="orderType" label="订单类型" align="center" width="75">
                  </el-table-column>
                  <el-table-column prop="brandName" label="品牌" align="center" width="70">
                  </el-table-column>
                  <el-table-column prop="dealerName" label="经销商" align="center" width="130" show-overflow-tooltip>
                  </el-table-column>
                  <el-table-column prop="designer" label="设计师" align="center" width="90" show-overflow-tooltip>
                  </el-table-column>
                  <el-table-column prop="designerTel" label="设计师电话" align="center" width="100">
                  </el-table-column>
                  <el-table-column prop="customer" label="客户名称" align="center" width="90" show-overflow-tooltip>
                  </el-table-column>
                  <el-table-column prop="customerTel" label="客户电话" align="center" width="100">
                  </el-table-column>
                  <el-table-column prop="address" label="终端地址" align="center" min-width="160" show-overflow-tooltip>
                  </el-table-column>
                  <el-table-column prop="expectTime" label="期望交期" align="center" width="90">
                  </el-table-column>
                  <el-table-column prop="flowName" label="跟单员" align="center" width="70" show-overflow-tooltip>
                  </el-table-column>
                  <el-table-column prop="splitName" label="拆单员" align="center" width="70" show-overflow-tooltip>
                  </el-table-column>
                  <el-table-column prop="offerName" label="报价员" align="center" width="70" show-overflow-tooltip>
                  </el-table-column>
                  <el-table-column prop="orderTime" label="下单时间" align="center" width="150">
                  </el-table-column>
                  <el-table-column prop="price" label="订单金额" align="center" width="90">
                  </el-table-column>
                  <el-table-column prop="orderStatus" label="订单状态" align="center" fixed="right" width="100">
                    <!-- <template slot-scope="scope">
                      <el-tag type="info" size="mini" disable-transitions>{{ scope.row.orderStatus }}</el-tag>
                    </template> -->
                  </el-table-column>
                  <el-table-column align="center" label="操作" fixed="right" width="120">
                    <template slot-scope="scope">
                      <el-button icon="el-icon-search" @click.stop="seeOrder(scope.row)" size="mini">进度详情</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  v-if="total > 0"
                  background
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-sizes="[20, 50, 100]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total">
                </el-pagination>
              </el-col>
            </el-row>
          </div>

        </div>
      </el-col>
    </el-row>

    <el-dialog :title="viewTitle" :visible.sync="orderVisible" width="1080px" top="8vh"
      :destroy-on-close="true" :lock-scroll="true" :append-to-body="true">
      <div style="padding: 10px 20px;">
        <el-row>
          <el-col :span="14">
            <div style="padding-right: 15px;">
              <div class="order-info">
                <span class="tit">订单号：</span>
                <span class="orderNum" @click="openDetails(orderDeatil)">
                  {{ orderDeatil.orderNum }}
                </span>
                <span class="tit mf">生产单号：</span>
                <span v-if="orderDeatil.productNum" style="color:#409EFF;font-weight: 500">{{ orderDeatil.productNum }}</span>
                <span v-else style="color:#999999;font-weight: 500">N/A</span>
                <span class="tit mf">订单类型：</span>
                <span>{{ orderDeatil.orderType }}</span>
              </div>
              <div class="order-info">
                <span class="tit">品牌：</span>
                <span>{{ orderDeatil.brandName }}</span>
                <span class="tit mf">当前状态：</span>
                <span>{{ orderDeatil.orderStatus }}</span>
                <span class="tit mf">金额：</span>
                <span>{{ orderDeatil.price != undefined ? orderDeatil.price : '-' }}</span>
              </div>
              <div class="order-info">
                <span class="tit">经销商：</span>
                <span :style="orderDeatil.dealerName && orderDeatil.dealerName.indexOf('VIP') > -1 ? 'font-weight: bold; color: #389e0d; font-style: italic;' : ''">
                  {{ orderDeatil.dealerName }}
                </span>
                <span class="tit mf">客户名称：</span>
                <span>{{ orderDeatil.customer }}</span>
                <span class="tit mf">客户电话：</span>
                <span>{{ orderDeatil.customerTel }}</span>
              </div>
              <div class="order-info">
                <span class="tit">详细地址：</span>
                <span>{{ orderDeatil.address }}</span>
              </div>
              <div class="order-info">
                <span class="tit">设计师：</span>
                <span>{{ orderDeatil.designer }}</span>
                <span class="tit mf">设计师电话：</span>
                <span>{{ orderDeatil.designerTel }}</span>
              </div>
              <div class="order-info">
                <span class="tit">跟单员：</span>
                <span>{{ orderDeatil.flowName || '-' }}</span>
                <span class="tit mf">拆单员：</span>
                <span>{{ orderDeatil.splitName || '-' }}</span>
                <span class="tit mf">报价员：</span>
                <span>{{ orderDeatil.offerName || '-' }}</span>
              </div>
              <div class="order-info">
                <span class="tit">下单日期：</span>
                <span>{{ orderDeatil.orderTime }}</span>
                <span class="tit mf">期望交期：</span>
                <span>{{ orderDeatil.expectTime }}</span>
              </div>
              <div class="order-info">
                <span class="tit" style="font-weight: bold;">当前订单总耗时：</span>
                <span style="font-weight: bold; color: #F56C6C;">{{ orderDeatil.time }}</span>
              </div>
            </div>
          </el-col>
          <el-col :span="10">
            <div style="padding-left: 20px; border-left: 1px solid #ebeef5; max-height: 74vh; overflow-y: auto;">
              <div style="">订单进度节点</div>
              <el-timeline style="padding-top: 20px;" class="order-track">
                <el-timeline-item v-if="orderDeatil.time" hide-timestamp size="large" :type="orderDeatil.orderStatus == '订单完成' ? 'primary' : ''">
                  <div>当前订单总耗时</div>
                  <div v-if="orderDeatil.orderStatus == '订单完成'" style="color: #606266; font-size: 12px;">(从下单到订单完成)</div>
                  <div v-else style="color: #606266; font-size: 12px;">(从下单到最后进度节点)</div>
                  <div class="time">{{ orderDeatil.time }}</div>
                </el-timeline-item>
                <el-timeline-item v-if="orderDeatil.productTime && orderDeatil.showIndex >= 15" hide-timestamp size="large" type="primary">
                  <div>生产耗时</div>
                  <div style="color: #606266; font-size: 12px;">(从工厂接单到生产完成)</div>
                  <div class="time">{{ orderDeatil.productTime }}</div>
                </el-timeline-item>
                <el-timeline-item v-if="orderDeatil.packTime && orderDeatil.showIndex >= 14" hide-timestamp size="large" type="primary">
                  <div>完成包装</div>
                  <div class="time">{{ orderDeatil.packTime }}</div>
                </el-timeline-item>
                <el-timeline-item v-if="orderDeatil.paintTime && orderDeatil.showIndex >= 13" hide-timestamp size="large" type="primary">
                  <div>完成油漆</div>
                  <div class="time">{{ orderDeatil.paintTime }}</div>
                </el-timeline-item>
                <el-timeline-item v-if="orderDeatil.woodTime && orderDeatil.showIndex >= 12" hide-timestamp size="large" type="primary">
                  <div>完成木工</div>
                  <div class="time">{{ orderDeatil.woodTime }}</div>
                </el-timeline-item>
                <el-timeline-item v-if="orderDeatil.scheduleTime && orderDeatil.showIndex >= 11" hide-timestamp size="large" type="primary">
                  <div>工厂排产</div>
                  <div class="time">{{ orderDeatil.scheduleTime }}</div>
                </el-timeline-item>
                <el-timeline-item v-if="orderDeatil.factoryTime && orderDeatil.showIndex >= 10" hide-timestamp size="large" type="primary">
                  <div>工厂接单</div>
                  <div class="time">{{ orderDeatil.factoryTime }}</div>
                </el-timeline-item>
                <el-timeline-item v-if="orderDeatil.sendTime && orderDeatil.showIndex >= 9" hide-timestamp size="large" type="primary">
                  <div>工厂分派</div>
                  <div class="time">{{ orderDeatil.sendTime }}</div>
                </el-timeline-item>
                <el-timeline-item v-if="orderDeatil.subsistTime && orderDeatil.showIndex >= 8" hide-timestamp size="large" type="primary">
                  <div>过预付款</div>
                  <div class="time">{{ orderDeatil.subsistTime }}</div>
                </el-timeline-item>
                <el-timeline-item v-if="orderDeatil.offerTime && orderDeatil.showIndex >= 7" hide-timestamp size="large" type="primary">
                  <div>订单报价</div>
                  <div class="time">{{ orderDeatil.offerTime }}</div>
                </el-timeline-item>
                <el-timeline-item v-if="orderDeatil.affirmTime && orderDeatil.showIndex >= 6" hide-timestamp size="large" type="primary">
                  <div>订单确认</div>
                  <div class="time">{{ orderDeatil.affirmTime }}</div>
                </el-timeline-item>
                <el-timeline-item v-if="orderDeatil.reviewTime && orderDeatil.showIndex >= 5" hide-timestamp size="large" type="primary">
                  <div>审单完成</div>
                  <div class="time">{{ orderDeatil.reviewTime }}</div>
                </el-timeline-item>
                <el-timeline-item v-if="orderDeatil.splitTime && orderDeatil.showIndex >= 4" hide-timestamp size="large" type="primary">
                  <div>拆单完成</div>
                  <div class="time">{{ orderDeatil.splitTime }}</div>
                </el-timeline-item>
                <el-timeline-item v-if="orderDeatil.allotTime && orderDeatil.showIndex >= 3" hide-timestamp size="large" type="primary">
                  <div>拆单分配</div>
                  <div class="time">{{ orderDeatil.allotTime }}</div>
                </el-timeline-item>
                <el-timeline-item v-if="orderDeatil.assessTime && orderDeatil.showIndex >= 2" hide-timestamp size="large" type="primary">
                  <div>技术评估</div>
                  <div class="time">{{ orderDeatil.assessTime }}</div>
                </el-timeline-item>
                <el-timeline-item v-if="orderDeatil.receiveTime && orderDeatil.showIndex >= 1" hide-timestamp size="large" type="primary">
                  <div>客服接单</div>
                  <div class="time">{{ orderDeatil.receiveTime }}</div>
                </el-timeline-item>
                <el-timeline-item v-if="orderDeatil.orderTime" hide-timestamp size="large" type="primary">
                  <div>下单</div>
                  <div class="time">{{ orderDeatil.orderTime }}</div>
                </el-timeline-item>
              </el-timeline>
            </div>
          </el-col>
        </el-row>

      </div>
    </el-dialog>

  </div>
</template>

<script>
  import axios from 'axios'

  import {
    getUser
  } from '@/utils/auth'

  import {
    getGroupInfoByUser,
    getOrders,
    ordersExport,
  } from '@/api/erp'

  import {
    getGroupReport
  } from '@/api/pub'

  export default {
    name: 'ddqjtj',
    data() {
      return {
        loading: false,
        currentPage: 1,
        pageSize: 20,
        total: 0,
        orderList: [],

        viewTitle: '',
        orderVisible: false,
        orderDeatil: {},

        excelLoading: false,

        searchForm: {
          search: '',
          orderType: null,
          mark: null,
          group: null,
          is_my: true,
          time: []
        },
        groupList: [],
        group: {
          dBrand: 1
        },

        chartOption: {},
      }
    },
    computed: {
      user: getUser
    },
    created() {
      getGroupInfoByUser({
        groupid: this.user.dGroupid
      }).then(response => {
        this.group = response.data
      });

      this.searchForm.group = this.user.dGroupid
      this.searchForm.brand = this.searchForm.group == 1 ? '首造' : '乔金斯'
      this.getGroupList()

      const myDate = new Date()
      // 近一月 获取上个月
      const lastMonthDate = new Date(myDate.getTime() - 31 * 24 * 3600 * 1000)
      const l_year = lastMonthDate.getFullYear()
      let l_month = lastMonthDate.getMonth() + 1
      let l_day = lastMonthDate.getDate()
      l_month = l_month > 9 ? l_month + '' : '0' + l_month
      l_day = l_day > 9 ? l_day + '' : '0' + l_day

      const year = myDate.getFullYear()
      let month = myDate.getMonth() + 1
      let day = myDate.getDate()
      month = month > 9 ? month + '' : '0' + month
      day = day > 9 ? day + '' : '0' + day
      this.searchForm.time.push(l_year + '-' + l_month + '-' + l_day)
      this.searchForm.time.push(year + '-' + month + '-' + day)

      this.getData()
    },
    methods: {
      getGroupList() {
        getGroupReport().then(response => {
          const arr = []
          for (const item of response.data) {
            if (item.nature === 0) {
              arr.push(item)
            }
          }
          this.groupList = arr
        })
      },

      Search() {
        this.currentPage = 1
        this.getData()
      },

      handleSizeChange(val) {
        this.pageSize = val
        this.getData()
      },
      handleCurrentChange(val) {
        this.currentPage = val
        this.getData()
      },

      getData() {
        if (this.loading) {
          this.$message({
            type: 'warning',
            message: '数据加载中'
          })
          return
        }
        let startTime = ''
        let endTime = ''
        if (this.searchForm.time !== null && this.searchForm.time.length === 2) {
          startTime = this.searchForm.time[0]
          endTime = this.searchForm.time[1]
        }
        const data = {
          groupid: this.searchForm.group,
          userId: this.user.dUserid,
          start: startTime,
          end: endTime,
          my: this.searchForm.is_my ? 1 : 0,
          search: this.searchForm.search,
          mark: this.searchForm.mark == '' ? null : this.searchForm.mark,
          orderType: this.searchForm.orderType == '' ? null : this.searchForm.orderType,
          page: this.currentPage,
          limit: this.pageSize
        }
        this.loading = true
        getOrders(data).then(response => {
          const data = response.data || []
          this.total = response.total
          this.orderList = data

          this.loading = false
        }).catch(err => {
          this.loading = false
        })
      },

      initCharts(list, type) {
        if (type === 'amount') {
          let names = []
          let totalAmountArr = []
          let totalPaidArr = []
          let totalArr = []

          for (const item of list) {
            names.push(item.dealerName)
            totalAmountArr.push(item.totalAmount)
            totalPaidArr.push(item.totalPaid)
            totalArr.push(item.total)
          }

          let option = {
            lang: {
              printChart: '打印图表',
              downloadPNG: '下载JPEG 图片',
              downloadJPEG: '下载JPEG文档',
              downloadPDF: '下载PDF 图片',
              downloadSVG: '下载SVG 矢量图',
              contextButtonTitle: '下载图片'
            },
            chart: {
              type: 'column'
            },
            title: {
              text: '经销商业绩金额统计'
            },
            xAxis: {
              categories: [...names]
            },
            credits: {
              enabled: false
            },
            plotOptions: {
              column: {
                borderRadius: '2px'
              }
            },
            series: [{
              name: '已完成订单金额',
              data: [...totalPaidArr]
            }, {
              name: '过预付款订单金额',
              data: [...totalAmountArr]
            }, {
              name: '总金额',
              data: [...totalArr]
            }]
          }

          this.chartOption[`${type}`] = option
          return
        }

        let circleData = []

        for (const item of list) {
          circleData.push({
            name: item.name,
            y: item.scaleTotal
          })
        }

        const circle = {
          lang: {
            printChart: '打印图表',
            downloadPNG: '下载JPEG 图片',
            downloadJPEG: '下载JPEG文档',
            downloadPDF: '下载PDF 图片',
            downloadSVG: '下载SVG 矢量图',
            contextButtonTitle: '下载图片'
          },
          chart: {
            plotBackgroundColor: null,
            plotBorderWidth: null,
            plotShadow: false,
            type: 'pie'
          },
          title: '经销商业绩总金额占比',
          credits: {
            enabled: false
          },
          tooltip: {
            pointFormat: '{series.name}: <b>{point.percentage:.2f}%</b>'
          },
          plotOptions: {
            pie: {
              allowPointSelect: true,
              cursor: 'pointer',
              dataLabels: {
                enabled: true, // 数据指引线
                format: '<b>{point.name}</b>: {point.percentage:.2f} %'
              },
              // showInLegend: true, // 数据标签
            }
          },
          series: [{
            name: '占比',
            colorByPoint: true,
            data: circleData
          }]
        }

        if (type) {
          this.chartOption[`${type}`] = circle
        }
      },

      // 弹窗信息
      seeOrder(row) {
        this.orderVisible = true
        this.viewTitle = '订单进度详情 - ' + row.orderNum
        this.orderDeatil = { ... row }
        // console.log(this.orderDeatil)

        this.tempHandleShowStep();
      },
      tempHandleShowStep() {
        // 1. 定义需要检查的时间字段列表（按检查顺序排列）
        const timeFields = [
          'receiveTime',
          'assessTime',
          'allotTime',
          'splitTime',
          'reviewTime',
          'affirmTime',
          'offerTime',
          'subsistTime',
          'sendTime',
          'factoryTime',
          'scheduleTime',
          'woodTime',
          'paintTime',
          'packTime',
          'productTime'
        ];

        // 2. 封装检查逻辑为独立函数（提高复用性和可读性）
        function isValidTimeField(timeStr) {
          // 如果字段不存在/为空，直接返回 true（触发 showIndex 自增）
          if (!timeStr) return true;
          // 检查条件：不包含'耗时' 或者 '耗时'后没有'-'
          const hasCostTime = timeStr.indexOf('耗时') !== -1;
          const hasHyphenAfterCostTime = hasCostTime && timeStr.split('耗时')[1].indexOf('-') !== -1;
          return !hasHyphenAfterCostTime;
        }

        // 3. 初始化 showIndex
        this.orderDeatil.showIndex = 0;

        // 4. 遍历字段列表，更新 showIndex
        for (let i = 0; i < timeFields.length; i++) {
          // 当前检查的字段名
          const fieldName = timeFields[i];
          // 当前 showIndex 等于遍历索引时，才检查对应字段
          if (this.orderDeatil.showIndex === i) {
            const timeValue = this.orderDeatil[fieldName];
            if (isValidTimeField(timeValue)) {
              this.orderDeatil.showIndex = i + 1;
            }
          }
        }
      },
      openDetails(row) {
        if (row.orderId.length > 36) {
          this.$router.push({
            path: '/work/order/' + row.orderId.substring(0, 36),
            query: {
              data: row.orderId.substring(37)
            }
          })
        } else {
          this.$router.push({ path: '/work/order/' + row.orderId.substring(0, 36) })
        }
        this.orderVisible = false
      },

      exportExcelAll() {
        if (!this.excelLoading) {
          this.excelLoading = true
          let brand = this.searchForm.group == 1 ? '首造' : '乔金斯'
          let startTime = ''
          let endTime = ''
          if (this.searchForm.time !== null && this.searchForm.time.length === 2) {
            startTime = this.searchForm.time[0]
            endTime = this.searchForm.time[1]
          }
          const data = {
            groupid: this.searchForm.group,
            userId: this.user.dUserid,
            start: startTime,
            end: endTime,
            search: this.searchForm.search,
            my: this.searchForm.is_my ? 1 : 0,
            mark: this.searchForm.mark,
            orderType: this.searchForm.orderType,
          }
          this.$message({
            message: '数据正在导出，请稍候'
          })
          axios({
            method: 'post',
            url: process.env.VUE_APP_BASE_API + '/api/orders/export',
            params: data,
            responseType: 'blob', // 表明返回服务器返回的数据类型
            headers: {
              'Content-Type': 'application/json'
            }
          }).then(res => { // 处理返回的文件流
            this.excelLoading = false
            const blob = new Blob([res.data]);
            const fileName = startTime + '~' + endTime + ' ' + brand + '订单全景表.xlsx';
            const elink = document.createElement('a');
            elink.download = fileName;
            elink.style.display = 'none';
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href);
            document.body.removeChild(elink);
          }).catch(err => {
            this.excelLoading = false
            this.$message({
              type: 'error',
              message: '导出失败，请稍候再试'
            })
          });
        }
      },

    }
  }
</script>

<style lang="scss" scoped>
  .el-table::before {
    height: 0!important;
  }

  .el-pagination {
    margin-top: 20px;
  }

  .orderNum {
    cursor: pointer;
    font-weight: 500;
    color: #409EFF;
  }
  .orderNum:hover {
    text-decoration: underline;
  }

  .order-info{
    width: 100%;
    margin-bottom: 20px;
    position: relative;
    .tit{
      color:#99a9bf;
    }
    .price{
      color:#F56C6C;
      font-weight: 500;
    }
    .mf{
      margin-left: 30px
    }
    .link{
      color:#409EFF;
      cursor: pointer;
      font-weight: 500;
      &:hover{
        opacity: 0.8;
      }
    }
    .file-item{
      cursor: pointer;
      background: #f6f7fa;
      color:#909399;
      padding: 10px 10px 10px 44px;
      position: relative;
      width: 100%;
      i{
        position: absolute;
        font-size: 30px;
        left: 10px;
        top:10px;
      }
      .file-name{
        width: 100%;
        height: 30px;
        font-size: 12px;
        line-height: 15px;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      &:hover{
        color:#409EFF;
      }
    }
    &:last-child{
      margin-bottom: 0;
    }
  }

  .order-track{
    overflow-x: auto;
    overflow-y: hidden;
    .order-track-info{
      width: 2240px;
      position: relative;
      .el-steps{
        .el-step{
          flex-basis: 160px!important;
        }
      }
    }
    .el-timeline-item {
      padding-bottom: 20px !important;
    }
    .time {
      margin-top: 8px;
      white-space: pre-line;
      color: #909399;
      line-height: 1.5;
      font-size: 13px;
    }
  }

  .view-info {
    width: 100%;
    position: relative;
    display: flex;
    flex-direction: column;

    .tit {
      color: #606266;
      display: flex;

      span {
        font-weight: bold;
      }
    }
  }
</style>
